import React, { useEffect, useState } from "react";
import firebaseConfig from "../config.js";
import CircularProgress from '@material-ui/core/CircularProgress';

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  useEffect(() => {
    firebaseConfig.auth().onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false);
    });
  }, []);
  if (loading) {
    return <div className="loadingcontainer"><div className="loading"><CircularProgress style={{'color': '#fff'}} /></div></div>;
  }
  return (
    <AuthContext.Provider value={{ currentUser }}>
      {children}
    </AuthContext.Provider>
  );
};